import { useFindingOnAsset } from "../../hooks";
import { TriageBar } from "~/components/TriageBar/TriageBar";
import { ScopeType } from "~/hooks/useScope";
import {
  getFindingSubheaders,
  getFindingTitle,
  isCheckFinding,
} from "~/pages/findings/FindingOnAsset/utils";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";

// space-wide asset triage bar
export function InfoBar() {
  const { isFeatureEnabled } = useFeatureFlags();
  const {
    finding,
    exception,
    exceptionActions,
    ticketActions,
    linkBack,
    linkToException,
    hasTicketingIntegration,
    hasSecurityPipelineIntegrations,
    activeScope,
    spaceScope,
    isExceptionFromAssetScope,
    loadingFindingOnAsset,
    loadingListExceptionGroup,
    handleSecurityPipelinePRDialogOpen,
  } = useFindingOnAsset();

  if (
    (activeScope?.type !== ScopeType.Workspace &&
      activeScope?.type !== ScopeType.Space) ||
    !spaceScope
  ) {
    // We only want to render this component for workspace or space scopes.
    return null;
  }

  return (
    <>
      <TriageBar
        {...{
          title: getFindingTitle({ finding }),
          fallbackPath: linkBack,
          subheaders: getFindingSubheaders({ finding }),
          triage: true,
          isLoading:
            exceptionActions.loading ||
            loadingListExceptionGroup ||
            loadingFindingOnAsset ||
            ticketActions.loading,
          asset: finding?.asset as any,
          availableRemediations: {
            exception: {
              active: true,
              shouldNavigateToSpaceLevel: !isExceptionFromAssetScope,
              hasException: !!exception,
              linkToException,
              onClick: !!exception
                ? exceptionActions.handleRemoveExceptionModalOpen
                : exceptionActions.handleSetExceptionModalOpen,
              disabled: exceptionActions.loading,
            },
            ticket: {
              active: true,
              onClick: hasTicketingIntegration
                ? ticketActions.handleCreateTicketDialogOpen
                : ticketActions.handleCreateTicketingIntegrationModalOpen,
            },
            securityPipeline: {
              active:
                isFeatureEnabled("Security Pipeline") &&
                hasSecurityPipelineIntegrations &&
                !isCheckFinding(finding),
              onClick: handleSecurityPipelinePRDialogOpen,
            },
          },
          ...(activeScope &&
            finding && {
              conversation: {
                scope: activeScope || "",
                findingMrn: finding.mrn,
                findingType: finding.__typename,
              },
            }),
        }}
      />
    </>
  );
}
